var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVesselWaitingData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 54,
    viewBox: "0 0 25 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_808_22775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.86694 12.4771C4.86694 11.8416 5.06874 11.2225 5.44324 10.7091L10.4432 3.85453C11.6415 2.2118 14.0924 2.21179 15.2907 3.85453L20.2906 10.7091C20.6651 11.2225 20.8669 11.8416 20.8669 12.4771V43.4914C20.8669 44.2871 20.5653 45.0703 19.9243 45.5418C16.0598 48.3847 9.5412 48.2489 5.81199 45.5381C5.16841 45.0703 4.86694 44.2871 4.86694 43.4914V12.4771Z",
    fill: "#FFBC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8669 12.4771V43.4914C19.8669 44.0548 19.6545 44.4989 19.3318 44.7362C17.6124 46.001 15.2421 46.6389 12.8242 46.6226C10.4052 46.6062 8.05977 45.9358 6.39996 44.7293C6.0795 44.4963 5.86694 44.0558 5.86694 43.4914V12.4771C5.86694 12.0534 6.00147 11.6407 6.25114 11.2984L11.2511 4.44385C12.05 3.34869 13.6839 3.34869 14.4827 4.44384L19.4827 11.2984C19.7324 11.6407 19.8669 12.0534 19.8669 12.4771Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07617 22.2435C8.07617 21.8176 8.21213 21.4028 8.46424 21.0596L11.2551 17.2598C12.0543 16.1717 13.6798 16.1717 14.4789 17.2598L17.2698 21.0596C17.5219 21.4028 17.6578 21.8176 17.6578 22.2435V41.848C17.6578 42.4478 17.3971 43.0313 16.8811 43.337C14.4771 44.7616 10.9766 44.8081 8.75217 43.3306C8.29332 43.0258 8.07617 42.4834 8.07617 41.9326V22.2435Z",
    fill: "#A4660A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_808_22775",
    x: 0.866943,
    y: 0.622482,
    width: 24,
    height: 53.0004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_808_22775"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_808_22775",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselWaitingData);
export default __webpack_public_path__ + "static/media/vessel-waiting-data.b79e3c71968085cd20755d9037a855cf.svg";
export { ForwardRef as ReactComponent };